(function ($) {
  'use strict';

  this.TD2023 = function () {};
}).bind(window)(jQuery);
